import clsx from 'clsx';
import React from 'react';

import SectionTitle from '@components/SectionTitle';
import { useSubscribeForm } from '@contexts/SubscribeFormContext';
import { OfferOption } from '@utils/backend-api/subscribe';
import { SelectedExtendedOffer } from '@utils/backend-api/subscribe';

import Offer from './Offer';

interface MultipleOffersProps {
  offers: OfferOption[];
  onOfferSelect: () => void;
  selectedOffer: SelectedExtendedOffer;
  setSelectedOffer: (plan: SelectedExtendedOffer) => void;
}

const MultipleOffers = ({
  offers,
  onOfferSelect,
  selectedOffer,
  setSelectedOffer,
}: MultipleOffersProps) => {
  const {
    user: { email, name },
  } = useSubscribeForm();
  return (
    <>
      <SectionTitle title="Step 2" />
      <div
        className={clsx('grid grid-cols-1 gap-0 sm:grid-cols-2 sm:gap-32', {
          'md:grid-cols-4 md:gap-8': offers.length > 3,
          'md:grid-cols-3 md:gap-28 md:px-96': offers.length === 3,
          'md:grid-cols-2 md:gap-32 md:px-[180px]': offers.length === 2,
          'pointer-events-none opacity-25 hover:opacity-50': !email || !name,
        })}
      >
        {offers.map((offer, index) => (
          <div
            key={`offer-card-${index}`}
            className="mb-48 border-0 border-b border-solid border-gray-300 px-16 pb-48 last:mb-0 last:border-b-0 last:pb-0 sm:mb-0 sm:border-b-0 sm:px-0 sm:pb-0"
          >
            <Offer
              onOfferSelect={onOfferSelect}
              offer={offer}
              selectedOfferCode={selectedOffer?.code}
              setSelectedOffer={setSelectedOffer}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default MultipleOffers;
